function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "person"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 11a4 4 0 10-4-4 4 4 0 004 4zm0-6a2 2 0 11-2 2 2 2 0 012-2zM12 13a7 7 0 00-7 7 1 1 0 002 0 5 5 0 0110 0 1 1 0 002 0 7 7 0 00-7-7z"
})));

function SvgIconUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBkYXRhLW5hbWU9InBlcnNvbiI+PHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBvcGFjaXR5PSIwIi8+PHBhdGggZD0iTTEyIDExYTQgNCAwIDEgMC00LTQgNCA0IDAgMCAwIDQgNHptMC02YTIgMiAwIDEgMS0yIDIgMiAyIDAgMCAxIDItMnoiLz48cGF0aCBkPSJNMTIgMTNhNyA3IDAgMCAwLTcgNyAxIDEgMCAwIDAgMiAwIDUgNSAwIDAgMSAxMCAwIDEgMSAwIDAgMCAyIDAgNyA3IDAgMCAwLTctN3oiLz48L2c+PC9nPjwvc3ZnPg==";
export { SvgIconUser as ReactComponent };